import { SVGProps } from 'react';

export const CheckMarkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M2.25 6.875L5.25 9.875L9.75 3.125'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
